export default __webpack_public_path__ + "static/media/wayalinks logo.b1e6a774.png";